import { defineComponent as n, createBlock as o, openBlock as r, unref as p, mergeProps as d, withCtx as v, createElementVNode as a } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const s = /* @__PURE__ */ n({
  name: "IconGearUpdate",
  __name: "IconGearUpdate",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const t = l;
    return (u, e) => (r(), o(p(m), d(t, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        a("path", { d: "M18.389 7.125a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" }, null, -1),
        a("path", { d: "M10.75 5.042V3.875h2.5v1.54a.75.75 0 0 0 1.5 0v-1.79a1.25 1.25 0 0 0-1.25-1.25h-3a1.25 1.25 0 0 0-1.25 1.25v1.252a7.742 7.742 0 0 0-2.146 1.24L6.012 5.493A1.25 1.25 0 0 0 4.306 5.95l-1.5 2.598a1.25 1.25 0 0 0 .453 1.705L4.347 10.9a8.035 8.035 0 0 0 .009 2.5L3.28 13.984l-.017.01A1.25 1.25 0 0 0 2.806 15.7l1.5 2.598a1.25 1.25 0 0 0 1.708.458l1.089-.63A8.11 8.11 0 0 0 9.25 19.37v1.254a1.25 1.25 0 0 0 1.25 1.25h3a1.25 1.25 0 0 0 1.25-1.25v-1.251a7.611 7.611 0 0 0 2.156-1.24l1.08.623a1.25 1.25 0 0 0 1.708-.458l1.5-2.598a1.25 1.25 0 0 0-.458-1.708l-1.089-.628a8.29 8.29 0 0 0 0-2.48l1.09-.628a1.25 1.25 0 0 0 .457-1.708.75.75 0 0 0-1.387.512l-1.051.607a1.272 1.272 0 0 0-.612 1.316 6.799 6.799 0 0 1 0 2.282 1.272 1.272 0 0 0 .612 1.316l1.014.585-1.25 2.165-1.007-.58a1.275 1.275 0 0 0-1.464.143 6.116 6.116 0 0 1-1.945 1.118 1.273 1.273 0 0 0-.854 1.195v1.167h-2.5v-1.167a1.277 1.277 0 0 0-.849-1.195 6.592 6.592 0 0 1-1.954-1.133 1.273 1.273 0 0 0-1.452-.133L5.48 17.332l-1.246-2.159.986-.536a1.276 1.276 0 0 0 .637-1.355 6.515 6.515 0 0 1-.008-2.268 1.276 1.276 0 0 0-.597-1.32L4.23 9.085l1.25-2.168L6.5 7.5a1.274 1.274 0 0 0 1.457-.143 6.242 6.242 0 0 1 1.94-1.12 1.274 1.274 0 0 0 .852-1.196" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M12 8.375a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-2.25 3.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
